<template>
  <div class="dredge-contain align direction">
    <img class="dredge-icon" src="../static/images/dredge-vip.png" alt="">
    <div class="dredge-tips" v-html="$props.vipText === '' ? $store.state.dredgeVipText :$props.vipText">
      成为VIP会员，即可免费使用直播监控功能、查<br>
      看历史直播数据及其他尊享服务
    </div>
    <a class="open-now" @click="goToOpenVIP">
      立即开通
    </a>
  </div>
</template>

<script>
export default {
  props:{
    vipText:{ type:String,default:'' }
  },
  methods: {
    goToOpenVIP() {
      this.$router.push({
        path: '/dredgeVip',
        query: {
          unSelect: Object.keys(this.$store.state.yearVipOnly || {}).toString(),
          road: location.href
        }
      })
      this.$store.commit('WRITEOVERLAYSHOW', { status: false })
    }
  },
}
</script>

<style lang="less" scoped>
.dredge-contain {
  margin: 0.2rem auto;
  height: 5rem;
  width: 6.9rem;
  padding-top: .8rem;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 .20rem 0 rgba(161, 174, 191, .5);

  .dredge-icon {
    width: 2rem;
    height: 0.6rem;
    margin-bottom: 0.44rem;
  }

  .dredge-tips {
    font-size: .28rem;
    font-weight: 400;
    color: rgba(161, 174, 191, 1);
    line-height: .40rem;
    margin-bottom: .45rem;
  }

  .open-now {
    width: 3.00rem;
    height: 1.00rem;
    line-height: 1rem;
    color: #FFFFFF;
    font-size: .36rem;
    background: linear-gradient(180deg, rgba(255, 201, 0, 1) 0%, rgba(255, 153, 0, 1) 100%);
    border-radius: .08rem;
  }
}
</style>